import React from 'react';
import { Link } from 'react-router-dom';

export default function DisclaimerPage() {
  return (
    <div className="glass-card rounded-2xl p-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-white mb-4">Legal Disclaimer</h1>
      <div className="text-gray-300 space-y-4 leading-relaxed">
        <p>
          The information provided by CFE Portal ("we," "us," or "our") on cfe-portal.com (the "Site") is for general informational and educational purposes only. All information on the Site is provided in good faith, however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Site.
        </p>
        <h2 className="text-xl font-semibold text-white pt-4">User-Generated Content</h2>
        <p>
          The Service includes content, reports, and comments submitted by users of the community. These submissions reflect the views and opinions of the individuals who post them and not necessarily those of the CFE Portal. We are not responsible for and do not endorse, guarantee, or assume liability for any content posted by users.
        </p>
        <h2 className="text-xl font-semibold text-white pt-4">Not Financial or Legal Advice</h2>
        <p>
          The information on this Service is not intended to be, and shall not be understood or construed as, financial or legal advice. The information contained on this Service is not a substitute for financial or legal advice from a professional who is aware of the facts and circumstances of your individual situation. We expressly recommend that you seek advice from a qualified professional.
        </p>
        <h2 className="text-xl font-semibold text-white pt-4">External Links Disclaimer</h2>
        <p>
          The Service may contain (or you may be sent through the Service) links to other websites or content belonging to or originating from third parties. Such external links are not investigated, monitored, or checked for accuracy, adequacy, validity, reliability, availability, or completeness by us.
        </p>
        <p>
          UNDER NO CIRCUMSTANCE SHALL WE HAVE ANY LIABILITY TO YOU FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE OR RELIANCE ON ANY INFORMATION PROVIDED ON THE SITE. YOUR USE OF THE SITE AND YOUR RELIANCE ON ANY INFORMATION ON THE SITE IS SOLELY AT YOUR OWN RISK.
        </p>
        <div className="text-center pt-6">
            <Link to="/" className="text-cyan-400 hover:text-cyan-300 font-semibold">
                &larr; Back to Landing Page
            </Link>
        </div>
      </div>
    </div>
  );
}